var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-content',{staticClass:"tbdc-fullwidthpage"},[_c('v-navigation-drawer',{ref:"leftDrawer",attrs:{"touchless":"","width":_vm.leftDrawer.width,"app":"","permanent":"","clipped":""}},[_c('v-container',[_vm._t("adminLeft")],2)],1),_c('v-container',{attrs:{"fluid":""}},[_vm._t("adminRight")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }